const contact = {
  path: '/contact',
  name: 'contact',
  component: () =>
    import(
      /* webpackChunkName: "contact" */ '@/components/contact/ContactIndex.vue'
    ),
  children: [
    {
      path: 'view/:id',
      component: () =>
        import(
          /* webpackChunkName: "contact" */ '@/components/contact/ContactView.vue'
        ),
      name: 'contactView',
    },
    {
      path: 'edit/:id',
      component: () =>
        import(
          /* webpackChunkName: "contact" */ '@/components/contact/ContactEdit.vue'
        ),
      name: 'contactEdit',
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "contact" */ '@/components/contact/ContactCreate.vue'
        ),
      name: 'contactCreate',
    },
  ],
  meta: { authorize: [], requiresAuth: true },
};

export default contact;
